import React, {useState, useEffect} from 'react';
import { useHistory } from 'react-router-dom'
import { makeStyles } from '@material-ui/core/styles';
import { Container, Box, TextField,Typography, Button } from '@material-ui/core';
import Paper from '@material-ui/core/Paper';
import { defaultProps } from 'react-spinkit';

import { storeUserBalance } from '../../../walletApi'
import { isAuthenticated } from "../../../../auth";


const useStyles = makeStyles((theme) => ({
    root: {
      display: 'flex',
      flexWrap: 'wrap',
      '& > *': {
        margin: theme.spacing(1),
        width: theme.spacing(50),
        height: theme.spacing(50),
      },
    },
    cardSpace:{marginTop: "250px", margin: "auto"}
  }));



const ConfirmDetails = (props) => {  
   const { user, token } = isAuthenticated();
   const history = useHistory();
    const intentsData = props.attachIntents.attributes
    const classes = useStyles();
    const [selectedData, setSelectedData] = useState({});

    useEffect(() =>{
      if(intentsData){
        const data ={
          amount: intentsData.amount,
          fee: intentsData.payments[0].attributes.fee,
          netAmount: intentsData.payments[0].attributes.net_amount

        }
        setSelectedData({...selectedData, data})

      }
    },[props])

 
    const handleSubmit = (e) =>{
        e.preventDefault();
        if(selectedData){

          const dataSend = {
            accountName:intentsData.payments[0].attributes.billing.name,
            userId:user._id,
            accountNumber:intentsData.payments[0].attributes.billing.phone,
            email:intentsData.payments[0].attributes.billing.email,
            netAmount: intentsData.payments[0].attributes.net_amount,
            currency: intentsData.payments[0].attributes.currency
           
          }
          console.log(dataSend.accountNumber)
          
          storeUserBalance(user._id,dataSend, token).then((data =[]) =>{
            if (data && data.error) {
              console.log(data.error) 
            } else {
              console.log(data)
              if(data){
                history.push("/user/wallet")
              }
            }
          })
        }
    }

    return(
        <Container>
        {
          !selectedData.data ? <div> Loading ... </div> : 
          <div className={classes.root}>
           <Box className={classes.cardSpace}>
                <Paper elevation={3}>
                  <Typography variant="h3"> Confirm Details</Typography>
                  <form noValidate autoComplete="off" onSubmit={handleSubmit}>
                    <Typography>TopUp Amount: {selectedData.data.amount}</Typography>
                    <Typography>Fee: {selectedData.data.fee} </Typography>
                    <Typography>Net Amount: {selectedData.data.netAmount}</Typography>
                    <br/>            
                      <Button
                        type='submit' 
                        variant="contained" 
                        color="secondary"
                      >
                        Confirm
                      </Button>
                  </form>
                </Paper>
           </Box>
          </div> 
        }
      </Container>
    )
}

export default ConfirmDetails;